import { render } from "./PromoSelectPlan.vue?vue&type=template&id=2dd578c8&scoped=true&ts=true"
import script from "./PromoSelectPlan.vue?vue&type=script&lang=ts"
export * from "./PromoSelectPlan.vue?vue&type=script&lang=ts"

import "./PromoSelectPlan.vue?vue&type=style&index=0&id=2dd578c8&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd578c8"]])

export default __exports__